<template>
  <div :class="mode == 'devel' ? 'block-show' : 'hide'" class="app-block"></div>
</template>
<script setup>
import { getCurrentInstance, onBeforeMount, ref } from "vue";
import { useAppStore } from "@/stores/useAppStore";
import { v4 as uuidv4 } from "uuid";
import { checkToken as checkTokenApi } from "@/api/auth";
import { getUserInfo as getUserInfoApi } from "@/api/user";
import { useCookies } from "vue3-cookies";

const { cookies } = useCookies();
const store = useAppStore();
const instance = getCurrentInstance();
const { appName, apiHost } = instance.appContext.config.globalProperties;

const uuid = ref("");
const token = ref("");
const mode = ref("");

const initUuid = () => {
  let uuidItem =
    document.cookie
      .match("(^|;)\\s*" + appName + "-uuid\\s*=\\s*([^;]+)")
      ?.pop() || "";
  if (uuidItem === "") {
    uuidItem = uuidv4();
    cookies.set(appName + "-uuid", encodeURI(uuidItem));
  }
  uuid.value = uuidItem;
};

const initAxiosHeader = () => {
  store.setAxiosHeaders({
    key: "uuid",
    val: uuid.value,
  });
};

const checkTokenResponse = async (data) => {
  if (data.result === true) {
    await store.setIsLogin(true);
    await store.setAxiosHeaders({
      key: "Authorization",
      val: "Bearer " + token.value,
    });
    await store.setAxiosHeaders({
      key: "uuid",
      val: uuid.value,
    });
    await store.setAxiosHeaders({
      key: "Accept",
      val: "application/json",
    });
    await store.setAxiosHeaders({
      key: "Content-Type",
      val: "application/json",
    });
    getUserInfo();
  } else {
    cookies.remove(appName + "-token", null);
  }
};

const checkToken = () => {
  checkTokenApi(apiHost, token.value, uuid.value)
    .then(({ data }) => checkTokenResponse(data))
    .catch(function (error) {
      console.error("checkToken", error);
    });
};

const initToken = () => {
  let tokenItem =
    document.cookie
      .match("(^|;)\\s*" + appName + "-token\\s*=\\s*([^;]+)")
      ?.pop() || "";
  if (tokenItem !== "") {
    token.value = decodeURI(tokenItem);
    checkToken();
  }
};

const setUserInfo = async (data) => {
  if (data.result) {
    await store.setUserInfo(data.content[0]);
  }
  store.setIsLogin(true);
};

const getUserInfo = () => {
  getUserInfoApi(apiHost, store.axiosHeaders)
    .then(({ data }) => setUserInfo(data))
    .catch(function (error) {
      console.error("checkToken", error);
    });
};

onBeforeMount(async () => {
  mode.value = store.envMode;
  initUuid();
  initAxiosHeader();
  initToken();
});
</script>
